import React, { useState, useEffect } from 'react';
import AWS from 'aws-sdk';

const S3Image = () => {
  const [imageUrl, setImageUrl] = useState(null);

  const s3 = new AWS.S3({
    accessKeyId: 'AKIATAMS4FZYBVRBXP6V',
    secretAccessKey: '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',
    region: 'us-east-2'
  });

  const getPresignedUrl = (imageName) => {
    const params = {
      Bucket: 'allamea-s3-emenu-storage',
      Key: `EmenuImages/${imageName}`, // Corrected here
      Expires: 60 // URL expiry time in seconds
    };

    return s3.getSignedUrl('getObject', params);
  };

  useEffect(() => {
    const url = getPresignedUrl('ad48dd5b-1b78-42aa-9cce-b52fe4d0b709.jpg');
    setImageUrl(url);
  }, []);

  return (
    <div>
      {imageUrl && <img src={imageUrl} alt="S3 Image" />}
    </div>
  );
};

export default S3Image;
